import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import SideNav from "./components/SideNav";
import HomeHero from "./sections/HomeHero";
import BioSection from "./sections/BioSection";
import ProjSection from "./sections/ProgettiAccademiciSection";
import MusicSection from "./sections/MusicaEventi";

function App() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const openNav = () => setIsNavOpen(true);
  const closeNav = () => setIsNavOpen(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && isNavOpen) {
        closeNav();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isNavOpen]);

  return (
    <div className="App">
      <Header isNavOpen={isNavOpen} onOpenNav={openNav} />
      <SideNav isNavOpen={isNavOpen} onCloseNav={closeNav} />
      
      <main>
        <HomeHero />
        <BioSection />
        <ProjSection />
        <MusicSection />
        {/* Altre sezioni qui */}
      </main>
    </div>
  );
}

export default App;
